import { Component, Input, OnInit, VERSION, ViewChild, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UserService } from 'app/rest/user.service';
import {  EventEmitter, Output, ElementRef, Renderer2 } from '@angular/core';
 import { QuillEditorComponent } from "ngx-quill";
import "quill-mention";
import NotificationParam = Rest_task.NotificationParam;
import { Rest_task } from 'app/modules/task/administration/services/rest_client_task';
 

@Component({
    selector: 'app-custom-quill-editor',
    templateUrl: './custom-quill-editor.component.html',
    styleUrls: ['./custom-quill-editor.component.css'],
    providers: [],
    encapsulation: ViewEncapsulation.None,
})
export class CustomQuillEditor implements OnInit, AfterViewInit {
    name = "Angular " + VERSION.major;
    //@ViewChild(QuillEditorComponent, { static: false }) editor: QuillEditorComponent;

    @ViewChild("quillEditorId")
    editor: QuillEditorComponent;
    checked = false;

    @Input() mentionsOptions: NotificationParam[];
    mentionsFormatted: any[] = [];

    @Input() toolbar: any[] = [];
    @Input() placeholder: String;
    @Input() editorHeight: string;
    @Input() maxLength: String;
    @Input() editorValue: string;
    @Output() editorValueChange = new EventEmitter<string>();
    //editorValue: string = "";

    modules: any;
    ngAfterViewInit(): void {
        setTimeout(() => {
            this.setEditorHeight();
        }, 500);
        this.formatMentions();
    }
    mentionId = "1";
    mentionIndex = 0;
    ngOnInit() {
        setTimeout(() => {
            //this.editor.quillEditor.setContents(this.obj);
        }, 5000);
        this.setQuillEditor()

    }

    setQuillEditor() {
        var toolBarAux = this.getToolBar()
        this.modules = {
            toolbar: toolBarAux,
            mention: {
                mentionListClass: "ql-mention-list mat-elevation-z8",
                allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                fixMentionsToQuill: false,
                showDenotationChar: false,
                spaceAfterInsert: true,
                onSelect: (item, insertItem) => {
                    const editor = this.editor.quillEditor;
                    insertItem(item);
                    // necessary because quill-mention triggers changes as 'api' instead of 'user'
                    editor.insertText(editor.getLength() - 1, "", "user");
                },
                source: (searchTerm, renderList) => {
                    const values = [...this.mentionsFormatted];
                    if (searchTerm.length === 0) {
                        renderList(values, searchTerm);
                    } else {
                        const matches = [];

                        values.forEach(entry => {
                            if (
                                entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
                            ) {
                                matches.push(entry);
                            }
                        });
                        renderList(matches, searchTerm);
                    }
                }
            }
        };
    }

    getToolBar() {
        var toolbarAux;
        if (this.toolbar != null && this.toolbar.length > 0) {
            toolbarAux = [...this.toolbar]
        }
        else {
            toolbarAux = false;
        }
        return toolbarAux;
    }

    formatMentions() {
        this.mentionsOptions?.forEach((param: NotificationParam) => {
            this.mentionsFormatted.push({ id: param.toString(), value: param.toString() });
        });
    }


    setEditorHeight() {
        // Seleccionamos el primer .ql-editor dentro de este componente
        const editor = this.el.nativeElement.querySelector('.ql-editor');

        if (editor) {
            editor.style.minHeight = this.editorHeight;  // Establecemos el min-height
        } else {
            console.log('No se encontró .ql-editor en este componente');
        }
    }
    content = "";

    constructor(private el: ElementRef) {

    }


    getTextHTML() {
        //no se usa
        const htmlValue = this.transformContentHTML(this.editorValue);
        console.log(htmlValue);
        console.log(this.editorValue);
        console.log(this.editor.quillEditor.getContents());
        const { ops } = this.editor.quillEditor.getContents();
        const result = ops.reduce((acc, { insert }) => {
            if (typeof insert === "string") {
                acc += insert;
            } else {
                acc += insert.mention.value;
            }

            return acc;
        }, "");
        console.log({ result });
    }

    onEditorBlur(event: any) {
        // El valor del editor es un Delta, podemos convertirlo a texto plano
        this.editorValueChange.emit(this.editorValue);
    }

    // EventEmitter para emitir cambios al padre

    bindEditorHTML(): void {
        //rValue = this.transformContentHTML(this.editorValue);
        this.editorValueChange.emit(this.editorValue);
    }


    transformContentHTML(input: string): string {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = input;
        const spans = tempDiv.querySelectorAll('span[data-id]');
        spans.forEach(span => {
            const dataId = span.getAttribute('data-id');
            if (dataId) {
                span.innerHTML = `{{${dataId}}}`;
            }
        });
        return tempDiv.innerHTML;
    }



}
